import React from 'react';

const DownloadSpeedIcon = () => {
  return (
  <svg width="21" height="21" viewBox="0 0 21 21" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M18.8125 14.4375V16.625C18.8125 17.8331 17.8331 18.8125 16.625 18.8125H4.375C3.16688 18.8125 2.1875 17.8331 2.1875 16.625V14.4375" stroke="#282828" strokeWidth="1.6" strokeLinecap="round" strokeLinejoin="round"/>
    <path d="M10.5 5.6875V16.1875" stroke="#282828" strokeWidth="1.6" strokeLinecap="round" strokeLinejoin="round"/>
    <path d="M13.3437 13.125L10.5 16.1875L7.65625 13.125" stroke="#333333" strokeWidth="1.6" strokeLinecap="round" strokeLinejoin="round"/>
  </svg>
  )
}

export default DownloadSpeedIcon;